import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchContactInfo } from "../lib/api";
import Logo from "./Logo";

const DEFAULT_CONTACT = {
  business_name: "Nexora Learning & Development Centre",
  email: "admissions@nexoracentre.ca",
  phone: "604-655-5306",
  hours: "Mon–Sat · 9am–6pm",
};

function phoneHref(p) {
  const digits = (p || "").replace(/\D/g, "");
  return `tel:+${digits.length === 10 ? `1${digits}` : digits}`;
}

export default function Footer() {
  const [contact, setContact] = useState(DEFAULT_CONTACT);

  useEffect(() => {
    fetchContactInfo()
      .then((d) => setContact({ ...DEFAULT_CONTACT, ...d }))
      .catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo to="/" variant="footer" data-testid="footer-logo" />
            <p className="mt-6 max-w-md text-slate-400 leading-relaxed text-sm">
              {contact.business_name || DEFAULT_CONTACT.business_name}. Currently
              offering Play-Based Behaviour & Emotional Support — 1-on-1
              developmental sessions designed around your child's goals.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="eyebrow text-slate-500">Explore</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <Link to="/programs" className="text-slate-300 hover:text-white">
                    All Programs
                  </Link>
                </li>
                <li>
                  <Link to="/camps" className="text-slate-300 hover:text-white">
                    Camps
                  </Link>
                </li>
                <li>
                  <Link to="/trial-class" className="text-slate-300 hover:text-white">
                    Book a Trial Class
                  </Link>
                </li>
                <li>
                  <Link
                    to="/play-based-support"
                    className="text-slate-300 hover:text-white"
                  >
                    Play-Based Support
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-slate-300 hover:text-white">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-slate-300 hover:text-white">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="eyebrow text-slate-500">Contact</p>
              <ul className="mt-4 space-y-3 text-sm text-slate-300">
                {contact.email && (
                  <li>
                    <a href={`mailto:${contact.email}`} className="hover:text-white break-all" data-testid="footer-email">
                      {contact.email}
                    </a>
                  </li>
                )}
                {contact.phone && (
                  <li>
                    <a href={phoneHref(contact.phone)} className="hover:text-white" data-testid="footer-phone">
                      {contact.phone}
                    </a>
                  </li>
                )}
                {contact.hours && <li>{contact.hours}</li>}
              </ul>
            </div>
            <div>
              <p className="eyebrow text-slate-500">Policies</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a href="#" className="text-slate-300 hover:text-white">
                    Privacy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-slate-300 hover:text-white">
                    Terms
                  </a>
                </li>
                <li>
                  <a href="#" className="text-slate-300 hover:text-white">
                    Safeguarding
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 grid gap-4">
          <p
            className="text-xs text-slate-400 leading-relaxed max-w-3xl"
            data-testid="footer-disclaimer"
          >
            Educational and developmental support only. No medical diagnosis or
            clinical treatment is provided. Families should consult qualified
            healthcare professionals for medical, psychological, or clinical
            concerns.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <p className="text-xs text-slate-500">
              © {new Date().getFullYear()} Nexora Learning & Development Centre.
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
